import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chart-seo",
  "use": "chart-seo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chart-seo\"><path d=\"M14.61 13.436l-.18.218.28.27h.79l4.99 5-1.49 1.49-5-4.99v-.79l-.27-.28a6.479 6.479 0 01-3.229 1.492v-2.034a4.496 4.496 0 003.388-3.388h2.034a6.473 6.473 0 01-1.314 3.012zM8.5 3v2.034A4.494 4.494 0 005 9.424a4.494 4.494 0 003.5 4.389v2.034A6.501 6.501 0 018.5 3zm2 0a6.505 6.505 0 015.423 5.423H13.89A4.496 4.496 0 0010.5 5.035V3z\" fill=\"#677078\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol